import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl + '/api';

const getAreas = async () => {
  try {
    const response = await axios.get(`${baseUrl}/areas`);
    return response.data;
  } catch (error) {
    console.error('Error obteniendo las áreas', error);
    throw error;
  }
};

const getTemaArea = async (areaId) => {
  try {
    const response = await axios.get(`${baseUrl}/tema-area`, {
      params: { areaTematicaId: areaId }, // Cambiado para enviar como parámetro de consulta
    });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error obteniendo los temas del área', error);
    throw error;
  }
};

const insertIndicador = async (indicadorData) => {
  try {
    const response = await axios.post(`${baseUrl}/insert-indicador`, indicadorData);
      return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error insertando el indicador', error);
    throw error;
  }
};
const getNivelConsulta = async () => {
  try {
    const response = await axios.get(`${baseUrl}/nivel-consulta`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error obteniendo los niveles de consulta', error);
    throw error;
  }
};
export const insertTemaArea = async (temaData) => {
  const response = await axios.post(`${baseUrl}/insert-tema-area`, temaData);
  return response.data;
};


export {
  getAreas,
  getTemaArea,
  insertIndicador,
  getNivelConsulta
};